import axios from 'axios';
import type { INotificationSettings } from '@bb/domain/dist/types';

const saveNotificationSettingsByUnsubscribeId = async (
  unsubscribeId: string,
  settings: INotificationSettings,
) => axios.post(`/unsubscribe/${unsubscribeId}`, settings);

export default saveNotificationSettingsByUnsubscribeId;
